/// <amd-module name="SuiteCommerce.SizeChart.Chart.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.SizeChart.Chart.Model", ["require", "exports", "Backbone"], function (require, exports, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ChartModel = /** @class */ (function (_super) {
        __extends(ChartModel, _super);
        function ChartModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(ChartModel.prototype, "internalId", {
            get: function () {
                return this.get('internalId');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ChartModel.prototype, "name", {
            get: function () {
                return this.get('recordName');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ChartModel.prototype, "title", {
            get: function () {
                return this.get('title');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ChartModel.prototype, "description", {
            get: function () {
                return this.get('description');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ChartModel.prototype, "chart", {
            get: function () {
                return this.get('chart');
            },
            enumerable: true,
            configurable: true
        });
        return ChartModel;
    }(Backbone_1.Model));
    exports.ChartModel = ChartModel;
});
